<template>
  <NavigationBarTop />

    <div class="container">
      
      <div class="logo-header">
        <!--<img src=logo alt="KC-Afrobraids salon logo" class="about-logo">-->
        <h1 class="visually-hidden">About KC-Afrobraids</h1>
      </div>

      <section class="story-section">
        <h2 class="section-head">Our Story: More Than Just a Salon</h2>

        <div class="story-content">
          <p>
            Established in 2018, <strong>KC-Afrobraids</strong> was founded on a simple principle: everyone deserves to feel beautiful and confident. What started as a small, passionate team has grown into a community staple, renowned for our commitment to <strong>healthy hair, innovative styling, and personalized care.</strong> We believe that hair is an expression of identity, and our mission is to help you tell your unique story.
          </p>
          <p>
            Our founder dreamed of creating a space that wasn't just about services, but about the <strong>experience</strong>. A place where clients can relax, connect, and receive expert advice tailored to their specific hair goals. That vision drives every consultation, every cut, and every color we perform.
          </p>
        </div>
      </section>

      <section class="mission-section">
        <h2 class="section-head">Our Core Values</h2>

        <div class="values-grid">

          <div class="value-card">
            <h3>Creativity</h3>
            <p>We stay ahead of trends, blending classic techniques with modern artistry to deliver styles that turn heads.</p>
          </div>

          <div class="value-card">
            <h3>Integrity</h3>
            <p>We use only the highest quality products and provide honest consultations, prioritizing the health of your hair above all else.</p>
          </div>

          <div class="value-card">
            <h3>Community</h3>
            <p>We foster a welcoming, inclusive environment where every client feels like family from the moment they walk through the door.</p>
          </div>

        </div>
      </section>

    </div>
</template>

<script>
import curly from '../../public/favicon.png'
import NavigationBarTop from '../components/NavigationBarTop.vue';

export default {
    name: 'About',
    components: {
        NavigationBarTop
    },
    data() {
      return {
        logo: curly
      }
    }
}
</script>

<style>
/* Base Layout & Containers*/
.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 1rem;
}

/*  Logo Header (Top Center) */
.logo-header {
    text-align: center; /* Centers the image */
    padding: 3rem 0 1rem;
    margin-bottom: 2rem;
    
}

.about-logo {
    max-width: 200px; 
    height: auto;
    display: inline-block; 
}

.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

/*  Main Story Section */
.story-section {
    margin-bottom: 4rem;
}

.section-head {
    font-size: 2.2rem;
    color: #1c1917;
    text-align: center;
    margin-bottom: 2rem;
}

.story-content p {
    font-size: 1.15rem;
    line-height: 1.8;
    color: #444;
    margin-bottom: 1.5rem;
    text-align: justify;
}

/*  Mission & Values Section*/
.mission-section {
    margin-bottom: 5rem;
}

.values-grid {
    display: grid;
    /* Mobile: Stack them */
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 0 1rem;
}

@media (min-width: 768px) {
    .values-grid {
        /* Tablet/Desktop: 3 columns */
        grid-template-columns: repeat(3, 1fr);
    }
}

.value-card {
    background-color: #f7f7f7;
    padding: 25px;
    border-radius: 10px;
    text-align: center;
    border-top: 5px solid crimson;
}

.value-card h3 {
    font-size: 1.4rem;
    color: #333;
    margin-top: 0;
    margin-bottom: 10px;
}

.value-card p {
    font-size: 1rem;
    color: #666;
}
</style>